const ULID_CITATION_MARKER = /\[[0-9A-HJKMNP-TV-Z]{26}\]/giu;
const NUMERIC_CITATION_MARKER = /\[(\d+)\]/gu;

export const formatPipelineCitationText = (value: string, citations: readonly { page: number | null }[]): string =>
  value
    .replace(ULID_CITATION_MARKER, "")
    .replace(NUMERIC_CITATION_MARKER, (marker, rawIndex: string) => {
      const index = Number.parseInt(rawIndex, 10);
      return index >= 1 && index <= citations.length ? "" : marker;
    })
    .replace(/[^\S\r\n]+/gu, " ")
    .replace(/[ \t]+(?=\r?$)/gmu, "")
    .trim();
